var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container examination" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("审批流设置")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "rulesForm",
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "审批流名称", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: {
                        size: "small",
                        placeholder: "请输入审批流名称",
                        filterable: "",
                        clearable: "",
                        maxlength: "20",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "适用部门", prop: "orgCode" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        "show-all-levels": false,
                        options: _vm.orgCodeList,
                        props: {
                          label: "orgName",
                          value: "orgCode",
                          children: "children",
                          checkStrictly: true,
                        },
                        size: "small",
                        placeholder: "请选择适用部门",
                      },
                      model: {
                        value: _vm.searchForm.orgCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orgCode", $$v)
                        },
                        expression: "searchForm.orgCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "h3",
            [
              _vm._v("审批流列表"),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.toOtherPages("examinationProcessDetails")
                    },
                  },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
          _c("lb-table", {
            attrs: {
              column: _vm.columns,
              data: _vm.page.list,
              pagination: "",
              align: "center",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }